module.exports = ".main-tree{display:inline-block;width:31%;vertical-align:top}\n"